<p-card
  class="p-card container"
  [class.proposal-section--valid]="isCompleted && (legalHeirFormControl.value || form.valid)">
  <h3 i18n>Bénéficiaires</h3>
  <p i18n>De quelle façon désirez vous nommer vos bénéficiaires?</p>

  <p-selectButton
    class="title-toggle"
    [options]="beneficiariesMethodSelectButtons | emTranslate"
    [formControl]="legalHeirFormControl"
    [allowEmpty]="false"
    optionLabel="label"
    optionValue="value"></p-selectButton>

  @if (!legalHeirFormControl.value) {
    <p-divider class="divider-margin-top" i18n
      ><strong>Bénéficiaires spécifiques</strong> (maximum de 6)
    </p-divider>
    @if (isDev && !isReadonly) {
      <p-button label="Simulate" class="btn--simulate" (onClick)="simulateBeneficiaries()"></p-button>
    }
    <div class="layout--column layout--gap-medium">
      @for (beneficiary of form.controls; track beneficiary; let i = $index; let first = $first) {
        <form [formGroup]="beneficiary">
          <div class="layout__inner-card">
            <h4 i18n>Bénéficiaire #{{ i + 1 }}</h4>
            <div class="layout--gap margin--bottom-small">
              <div class="layout--full-width">
                <label class="label-top" for="firstName" i18n>Prénom</label>
                <input
                  [ngClass]="{
                    'error--input':
                      beneficiary.controls.firstName.invalid && beneficiary.controls.firstName.touched,
                  }"
                  i18n-placeholder
                  placeholder="Prénom"
                  [formControl]="beneficiary.controls.firstName"
                  id="firstName"
                  type="text"
                  [maxLength]="25"
                  pInputText />
                @if (beneficiary.controls.firstName.touched) {
                  @if (beneficiary.controls.firstName.hasError('maxlength')) {
                    <p class="error margin--top-smaller" i18n> Maximum de 25 caractères</p>
                  }
                  @if (beneficiary.controls.firstName.hasError('noSpecialCharacterInvalid')) {
                    <p class="error margin--top-smaller" i18n>Aucun caractère spécial</p>
                  }
                  @if (beneficiary.controls.firstName.hasError('noNumberInvalid')) {
                    <p class="error margin--top-smaller" i18n>Aucun chiffre n'est permis</p>
                  }
                }
              </div>
              <div class="layout--full-width">
                <label class="label-top" for="lastName" i18n>Nom de famille</label>
                <input
                  [ngClass]="{
                    'error--input':
                      beneficiary.controls.lastName.invalid && beneficiary.controls.lastName.touched,
                  }"
                  i18n-placeholder
                  placeholder="Nom de famille"
                  [formControl]="beneficiary.controls.lastName"
                  id="lastName"
                  type="text"
                  [maxLength]="25"
                  pInputText />
                @if (beneficiary.controls.lastName.touched) {
                  @if (beneficiary.controls.lastName.hasError('maxlength')) {
                    <p class="error margin--top-smaller" i18n> Maximum de 25 caractères</p>
                  }
                  @if (beneficiary.controls.lastName.hasError('noSpecialCharacterInvalid')) {
                    <p class="error margin--top-smaller" i18n>Aucun caractère spécial</p>
                  }
                  @if (beneficiary.controls.lastName.hasError('noNumberInvalid')) {
                    <p class="error margin--top-smaller" i18n>Aucun chiffre n'est permis</p>
                  }
                }
              </div>
              <div class="layout--full-width">
                <label class="label-top" for="birthday" i18n>Date de naissance</label>
                <input
                  [ngClass]="{
                    'error--input':
                      beneficiary.controls.birthday.invalid && beneficiary.controls.birthday.touched,
                  }"
                  i18n-placeholder
                  placeholder="JJ/MM/AAAA"
                  [formControl]="beneficiary.controls.birthday"
                  id="birthday"
                  mask="d0/M0/0000"
                  [dropSpecialCharacters]="false"
                  pInputText />
              </div>
              <div class="layout--full-width">
                <label class="label-top" for="linkBeneficiary" i18n>Lien</label>
                <p-dropdown
                  id="linkBeneficiary"
                  [options]="beneficiaryLinkOptions | emTranslate"
                  [styleClass]="
                    beneficiary.controls.link.invalid && beneficiary.controls.link.touched
                      ? 'error--input'
                      : ''
                  "
                  optionLabel="name"
                  optionValue="value"
                  i18n-placeholder
                  placeholder="Choisir"
                  [formControl]="beneficiary.controls.link"></p-dropdown>
              </div>
              <div class="layout--full-width">
                <label class="label-top" for="revocable" i18n>Statut</label>
                <p-dropdown
                  id="revocable"
                  [options]="revocableOptions | emTranslate"
                  [styleClass]="
                    beneficiary.controls.revocable.invalid && beneficiary.controls.revocable.touched
                      ? 'error--input'
                      : ''
                  "
                  optionLabel="name"
                  optionValue="value"
                  i18n-placeholder
                  placeholder="Choisir"
                  [formControl]="beneficiary.controls.revocable"></p-dropdown>
              </div>
              <div class="layout--full-width">
                <label class="label-top" for="share" i18n>Entrer un pourcentage</label>
                <p-inputNumber
                  [min]="1"
                  [max]="100"
                  suffix=" %"
                  [ngClass]="{
                    'ng-invalid ng-dirty':
                      beneficiary.controls.share.invalid && beneficiary.controls.share.touched,
                  }"
                  id="share"
                  [formControl]="beneficiary.controls.share"
                  i18n-placeholder
                  placeholder="--%"></p-inputNumber>
                <p class="share--coverage">
                  @if (coverageShare(i) > 0) {
                    <span>{{ coverageShare(i) | currency }}</span>
                  } @else {
                    <span>-- $</span>
                  }
                </p>
              </div>
            </div>
            @if (form.length > 1 && !isReadonly) {
              <button
                pButton
                type="button"
                i18n-label
                label="Supprimer bénéficiaire #{{ i + 1 }}"
                icon="pi pi-trash"
                class="p-button-text p-button-plain"
                (click)="removeBeneficiary(i)"></button>
            }
          </div>
        </form>
      }
    </div>
    @if (totalShareLeft !== 0) {
      <div class="share">
        <p class="share--total-left"
          ><strong>{{ totalShareLeft }}%</strong></p
        >
        <p i18n>restant</p>
      </div>
    }
    @if (!isReadonly) {
      <p-button
        class="margin--top-medium flex justify-content-end"
        [disabled]="form.controls.length >= 6"
        (onClick)="addEmptyBeneficiary()"
        i18n-label
        label="Ajouter un bénéficiaire"
        icon="pi pi-plus"></p-button>
    }
    <!--        Trustee-->
    @if (hasTrustee()) {
      <p-divider class="divider-margin-top" i18n><strong>Fiduciaire</strong></p-divider>
    }
    <div class="layout--column layout--gap-medium">
      @for (beneficiary of form.controls; track beneficiary; let i = $index; let first = $first) {
        @if (beneficiary.controls.trustee; as trustee) {
          <form [formGroup]="trustee">
            <div class="layout__inner-card">
              <h4 i18n
                >Fiduciaire de {{ beneficiary.controls.firstName.value }}
                {{ beneficiary.controls.lastName.value }}</h4
              >
              <div class="layout--gap margin--bottom-small">
                <div class="layout--full-width">
                  <label class="label-top" for="trusteeFirstName" i18n>Prénom</label>
                  <input
                    [ngClass]="{
                      'error--input':
                        trustee.controls.firstName.invalid && trustee.controls.firstName.touched,
                    }"
                    i18n-placeholder
                    placeholder="Prénom"
                    [formControl]="trustee.controls.firstName"
                    id="trusteeFirstName"
                    type="text"
                    [maxLength]="25"
                    pInputText />
                  @if (trustee.controls.firstName.touched) {
                    @if (trustee.controls.firstName.hasError('maxlength')) {
                      <p class="error margin--top-smaller" i18n>Maximum de 25 caractères</p>
                    }
                    @if (trustee.controls.firstName.hasError('noSpecialCharacterInvalid')) {
                      <p class="error margin--top-smaller" i18n>Aucun caractère spécial</p>
                    }
                    @if (trustee.controls.firstName.hasError('noNumberInvalid')) {
                      <p class="error margin--top-smaller" i18n>Aucun chiffre n'est permis</p>
                    }
                  }
                </div>
                <div class="layout--full-width">
                  <label class="label-top" for="trusteeLastName" i18n>Nom de famille</label>
                  <input
                    [ngClass]="{
                      'error--input': trustee.controls.lastName.invalid && trustee.controls.lastName.touched,
                    }"
                    i18n-placeholder
                    placeholder="Nom de famille"
                    [formControl]="trustee.controls.lastName"
                    id="trusteeLastName"
                    type="text"
                    [maxLength]="25"
                    pInputText />
                  @if (trustee.controls.lastName.touched) {
                    @if (trustee.controls.lastName.hasError('maxlength')) {
                      <p class="error margin--top-smaller" i18n>Maximum de 25 caractères</p>
                    }
                    @if (trustee.controls.lastName.hasError('noSpecialCharacterInvalid')) {
                      <p class="error margin--top-smaller" i18n>Aucun caractère spécial</p>
                    }
                    @if (trustee.controls.lastName.hasError('noNumberInvalid')) {
                      <p class="error margin--top-smaller" i18n>Aucun chiffre n'est permis</p>
                    }
                  }
                </div>
                <div class="layout--full-width">
                  <label class="label-top" for="trusteeBirthday" i18n>Date de naissance</label>
                  <input
                    [ngClass]="{
                      'error--input': trustee.controls.birthday.invalid && trustee.controls.birthday.touched,
                    }"
                    i18n-placeholder
                    placeholder="JJ/MM/AAAA"
                    [formControl]="trustee.controls.birthday"
                    id="trusteeBirthday"
                    mask="d0/M0/0000"
                    [dropSpecialCharacters]="false"
                    pInputText />
                </div>
                <div class="layout--full-width">
                  <label class="label-top" for="trusteeSex" i18n>Sexe</label>
                  <p-dropdown
                    id="trusteeSex"
                    [options]="sexOptions | emTranslate"
                    [styleClass]="
                      trustee.controls.sex.invalid && trustee.controls.sex.touched ? 'error--input' : ''
                    "
                    optionLabel="name"
                    optionValue="value"
                    i18n-placeholder
                    placeholder="Choisir"
                    [formControl]="trustee.controls.sex"></p-dropdown>
                </div>
                <div class="layout--full-width">
                  <label class="label-top" for="link" i18n
                    >Lien avec {{ beneficiary.controls.firstName.value }}
                    {{ beneficiary.controls.lastName.value }}</label
                  >
                  <p-dropdown
                    id="link"
                    [options]="trusteeLinkOptions | emTranslate"
                    [styleClass]="
                      trustee.controls.link.invalid && trustee.controls.link.touched ? 'error--input' : ''
                    "
                    optionLabel="name"
                    optionValue="value"
                    i18n-placeholder
                    placeholder="Choisir"
                    [formControl]="trustee.controls.link"></p-dropdown>
                </div>
              </div>
            </div>
          </form>
        }
      }
    </div>
  }
</p-card>
